import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Card,
  message,
  Spin,
  Upload,
  Checkbox,
  Row,
  Col,
  Image,
  Popconfirm,
} from "antd";
import {
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_BACK_CASE_NUMBER,
  POST_DELETE_IMAGE_NEW,
  POST_UPLOAD_IMAGE_NEW,
} from "../../../API/apiUrls";
import axios from "axios";
import Dragger from "antd/es/upload/Dragger";
import {
  InboxOutlined,
  FilePdfOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import ThaiDatePickerTime from "../../../../hook/ThaiDatePickerTime";
import Compressor from "compressorjs";
import ClearAdvancePaymentOnce from "./ClearAdvancePaymentOnce";

const UpdateStatusBlackNumber = ({
  open,
  close,
  dataDefault,
  funcUpdateStatus,
}) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");

  const [loading, setLoading] = useState(false);
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [dataForm, setDataForm] = useState({});
  // ✅ เพิ่ม State สำหรับจัดการรูปภาพ
  const [fileList, setFileList] = useState([]);
  const [allImg, setAllImg] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileListByContract, setFileListByContract] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  const [isModalClearAdvancePayment, setIsModalClearAdvancePayment] =
    useState(false);

  const dataDefaultValues = useCallback(
    (dataDefault) => {
      form.setFieldsValue({
        blackNumber: dataDefault.blackNumber,
        considerationDate:
          dataDefault.currentStatus === 4
            ? null
            : dayjs(dataDefault.considerationDate),
        memo: dataDefault.mark,
      });
      console.log("✅ Default values set:", dataDefault);
    },
    [form],
  );

  useEffect(() => {
    if (open && dataDefault.currentStatus === 5) {
      console.log("loadData", dataDefault);
      dataDefaultValues(dataDefault);
      loadPath();
    }
  }, [open, dataDefault, dataDefaultValues]);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  const loadPath = async () => {
    setLoading(true);
    try {
      const imgRes = await axios.get(
        `${GET_LOAD_IMAGE_NEW_ALL}/5/${dataDefault.loanId}`,
        {
          headers: HEADERS_UPIMAGE,
        },
      );

      const imgResData = imgRes.data;
      if (!imgResData) {
        message.warning("ไม่พบข้อมูล lawsuit");
        setFileListByContract([]);
        return;
      }

      console.log("imgResData Data:", imgResData);
      setFileListByContract(imgResData);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาดในการโหลดข้อมูล: ${error.message}`);
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  };

  const sendStatus = async (data) => {
    try {
      const res = await axios.post(POST_BACK_CASE_NUMBER, data, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        console.log("resQuery", res.data);
        return { success: true, status: res.status };
      }

      return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
    } catch (error) {
      console.error("Error sending data:", error);
      const errorMessage =
        error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล";
      return { success: false, error: errorMessage };
    }
  };

  const handleUpLoadIMG = useCallback(async (resultImgs, menu, data) => {
    const newFormData = new FormData();

    try {
      newFormData.append("id", data.id);
      newFormData.append("notis", menu);

      const sortedImgs = resultImgs
        .filter((img) => img.originalIndex !== undefined)
        .sort((a, b) => {
          const typeDiff = a.type - b.type;
          if (typeDiff !== 0) return typeDiff;
          return a.originalIndex - b.originalIndex;
        });

      for (const file of sortedImgs) {
        newFormData.append("file", file.imageCompressedFile);
        newFormData.append("menuType", menu);
        newFormData.append("imageType", file.type);
      }
      console.log("newFormData", newFormData);

      const response = await axios.post(POST_UPLOAD_IMAGE_NEW, newFormData, {
        headers: HEADERS_UPIMAGE,
      });

      if (response.status === 200) {
        return { success: true, status: response.status };
      }

      return { success: false, error: "อัปโหลดรูปไม่สำเร็จ" };
    } catch (error) {
      console.error("Upload error:", error);
      return { success: false, error: error.message };
    }
  }, []);

  const onChangeConsiderationDate = (date, dateString) => {
    console.log(date, dateString);

    setDataForm({ ...dataForm, considerationDate: dateString });
  };

  const onChangeInputBlackNumber = (value) => {
    console.log(value);
  };

  const onFinish = async (values) => {
    console.log("Form values:", values);

    // ========================================
    // Validation
    // ========================================
    if (fileList.length < 1 && fileListByContract.length < 1) {
      message.error("กรุณาเลือกไฟล์เพื่ออัปโหลด");
      return;
    }

    const postStatus = {
      lawsuitId: dataDefault.lawsuitId,
      loanId: dataDefault.loanId,
      considerationDate: dayjs(values.considerationDate).format(),
      blackCaseNumber: values.blackNumber,
      mark: values.memo,
      userId: userId,
    };

    console.log("postStatus", postStatus);

    setLoading(true);
    try {
      const statusResult = await sendStatus(postStatus);

      if (!statusResult.success) {
        throw new Error(statusResult.error);
      }
      console.log("✅ ขั้นตอนที่ 1: บันทึกข้อมูลสำเร็จ");

      const shouldUploadImages = allImg?.length > 0;

      if (shouldUploadImages) {
        console.log(
          `📤 ขั้นตอนที่ 2: กำลังอัปโหลดรูปภาพ ${allImg.length} ไฟล์...`,
        );

        const uploadResult = await handleUpLoadIMG(allImg, 5, {
          id: dataDefault.loanId,
        });

        if (uploadResult.success) {
          console.log("✅ ขั้นตอนที่ 2: อัปโหลดรูปภาพสำเร็จ");
          message.success("บันทึกรูปสำเร็จ");
        } else {
          console.warn("⚠️ อัปโหลดรูปภาพล้มเหลว:", uploadResult.error);
          message.warning("บันทึกข้อมูลสำเร็จ แต่อัปโหลดรูปภาพล้มเหลว");
          // ไม่ throw เพราะข้อมูลหลักบันทึกสำเร็จแล้ว
        }
      } else {
        console.log("ℹ️ ไม่มีรูปภาพที่ต้องอัปโหลด");
      }

      // ========================================
      // ✅ ขั้นตอนที่ 3: อัปเดทสถานะหน้าหลัก
      // ========================================
      if (funcUpdateStatus) {
        console.log("🔄 ขั้นตอนที่ 3: กำลังอัปเดทสถานะ...");
        await funcUpdateStatus();
        console.log("✅ ขั้นตอนที่ 3: อัปเดทสถานะสำเร็จ");
      }

      // ========================================
      // ✅ ขั้นตอนที่ 4: แสดง Success Message และปิดหน้าต่าง
      // ========================================
      message.success({
        content: "บันทึกคำพิพากษาสำเร็จ",
        duration: 2,
      });

      if (!dataDefault.approvalClearPayment) {
        Modal.confirm({
          title: "เคลียร์เงินทดรองจ่าย",
          icon: <ExclamationCircleOutlined style={{ color: "#1890ff" }} />,
          content: "ต้องการเคลียร์เงินทดรองจ่ายตอนนี้เลยหรือไม่?",
          okText: "เคลียร์เงิน",
          okType: "primary",
          cancelText: "ไม่ใช่ตอนนี้",
          centered: true,
          onOk: () => {
            setIsModalClearAdvancePayment(true);
          },
          onCancel: () => {
            handleCancel();
          },
        });
      } else {
        handleCancel();
      }
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาด:", error);
      message.error(error.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครับ");
  };

  const onChangeInputMemo = (value) => {
    console.log(value);
  };

  const compressImage = async (file, types, index) => {
    return new Promise((resolve) => {
      let quality;
      if (file.size >= 2500000) quality = 0.1;
      else if (file.size >= 2000000) quality = 0.15;
      else if (file.size >= 1500000) quality = 0.2;
      else if (file.size >= 1000000) quality = 0.3;
      else quality = 0.5;

      new Compressor(file, {
        quality: quality,
        success: (result) => {
          const fileOptions = {
            type: result.type,
            lastModified: Date.now(),
          };
          const compressedFileAsFile = new File(
            [result],
            file.name,
            fileOptions,
          );

          const image = {
            imageCompressedFile: compressedFileAsFile,
            type: types,
            originalIndex: index,
          };

          setAllImg((prev) => [...prev, image]);
          setLoading(false);
          resolve(true);
        },
        error: (err) => {
          console.error("Compressor error:", err);
          message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
          setLoading(false);
          resolve(true);
        },
      });
    });
  };

  // ลบรูป (รับ array)
  const handleDeleteIMG = async (images) => {
    if (!images || images.length === 0) return;

    setLoading(true);
    try {
      // ✅ แก้ axios config - headers ต้องอยู่ใน object เดียวกับ data
      const res = await axios.delete(POST_DELETE_IMAGE_NEW, {
        data: images,
        headers: HEADERS_UPIMAGE,
      });

      if (res.status === 200) {
        const selectedPaths = new Set(images.map((img) => img.path));
        setFileListByContract((prev) =>
          prev.filter((img) => !selectedPaths.has(img.path)),
        );
        message.success("ลบรูปสำเร็จ");
      }
    } catch (err) {
      message.error("เกิดข้อผิดพลาด ลบรูปไม่สำเร็จ");
      console.error("err", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ ลบรูปเดียว - ส่งเป็น array
  const handleDeleteSingleImage = async (image) => {
    await handleDeleteIMG([image]);
  };

  // ✅ Preview รูป
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
      let pdfUrl = file.url;
      if (!pdfUrl && file.originFileObj) {
        pdfUrl = URL.createObjectURL(file.originFileObj);
      }
      window.open(pdfUrl, "_blank");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // ✅ Handle change file list
  const handleChangeIMG = ({ fileList: newFileList, file }) => {
    const updatedFileList = newFileList.map((f) => {
      if (f.type === "application/pdf" || f.name.endsWith(".pdf")) {
        // Custom icon logic ถ้าต้องการ
      }
      return f;
    });

    setFileList(updatedFileList);

    if (file.status === "removed") {
      setAllImg((prevAllImg) => {
        return prevAllImg.filter((img) => img.originalIndex !== file.uid);
      });
    }

    if (
      file.status === "done" ||
      file.status === "removed" ||
      file.status === "error"
    ) {
      setLoading(false);
    }
  };

  // ✅ Before upload
  const beforeUpts = async (file, ty) => {
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      const image = {
        imageCompressedFile: file,
        type: ty,
        originalIndex: file.uid,
      };
      setAllImg((prev) => [...prev, image]);
      return false;
    }

    if (file.size > 5000000) {
      message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
      return Upload.LIST_IGNORE;
    }

    try {
      setLoading(true);
      await compressImage(file, ty, file.uid);
      return false;
    } catch (error) {
      console.error("File processing error:", error);
      message.error("File processing failed.");
      return Upload.LIST_IGNORE;
    }
  };

  // ✅ Upload Props
  const uploadProps = {
    name: "file",
    multiple: true,
    accept: "image/*,.pdf",
    listType: "picture",
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChangeIMG,
    beforeUpload: (file) => beforeUpts(file, 3), //3 = ไฟล์คำพิพากษา
    iconRender: (file) => {
      if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        return (
          <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f" }} />
        );
      }
      return null;
    },
  };

  const FormDisabledDemo = () => {
    return (
      <>
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{
            memo: null,
          }}
        >
          <Form.Item label="เลขสัญญา/เจ้าของสัญญา" name="ownerSign">
            {`${dataDefault?.CONTNO}/${dataDefault?.SNAM}
            ${dataDefault?.NAME1} ${
              dataDefault?.NAME2 ? dataDefault?.NAME2 : ""
            }`}
          </Form.Item>
          <Form.Item
            label="หมายเลขคดีดำ"
            name="blackNumber"
            rules={[
              {
                required: true,
                message: "กรุณากรอกหมายเลขคดีดำ !",
              },
            ]}
          >
            <Input onChange={(e) => onChangeInputBlackNumber(e.target.value)} />
          </Form.Item>
          <Form.Item
            label="วันนัดพิจารณาคดี"
            name="considerationDate"
            rules={[
              {
                required: true,
                message: "โปรดเลือกวันที่",
              },
            ]}
          >
            <ThaiDatePickerTime
              showTime={{
                format: "HH:mm",
              }}
              onChange={onChangeConsiderationDate}
            />
          </Form.Item>

          <Form.Item
            label="อัพโหลดไฟล์คำฟ้อง"
            name="file"
            // rules={[{ required: true, message: "กรุณาอัปโหลดไฟล์คำพิพากษา !" }]}
          >
            <Dragger
              {...uploadProps}
              style={{
                padding: "20px",
                background: "#fafafa",
                borderRadius: 8,
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined style={{ color: "#1890ff", fontSize: 48 }} />
              </p>
              <p className="ant-upload-text" style={{ fontSize: 16 }}>
                กรุณาคลิกหรือลากเพื่อเลือกไฟล์
              </p>
              {/* <p className="ant-upload-hint" style={{ color: "#999" }}>
                       รองรับการอัปโหลดแบบเดี่ยวหรือแบบกลุ่ม (ไฟล์ละไม่เกิน 5 MB)
                     </p> */}
            </Dragger>
          </Form.Item>
          {(() => {
            const filteredFiles =
              fileListByContract?.filter((e) => e.imageType === 3) || [];
            if (filteredFiles.length === 0) return null;

            return (
              <Form.Item label="ไฟล์คำฟ้อง" name="file">
                <Spin spinning={loading} size="large" tip="Loading...">
                  <Row gutter={[8, 8]} justify="center">
                    {filteredFiles.map((e, index) => {
                      const isPdf = e.path?.toLowerCase().endsWith(".pdf");
                      const isSelected = selectedImages?.some(
                        (img) => img.path === e.path,
                      );

                      return (
                        <Col
                          key={e.path || index}
                          xs={12}
                          sm={8}
                          md={6}
                          lg={6}
                          xl={6}
                        >
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {/* ปุ่มลบรูปเดียว */}
                            <Popconfirm
                              title="ยืนยันการลบ"
                              description="ต้องการลบไฟล์นี้?"
                              onConfirm={() => handleDeleteSingleImage(e)}
                              okText="ลบ"
                              cancelText="ยกเลิก"
                              okButtonProps={{ danger: true }}
                            >
                              <Button
                                type="primary"
                                danger
                                size="small"
                                icon={<DeleteOutlined />}
                                style={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  zIndex: 10,
                                }}
                              />
                            </Popconfirm>

                            <Card
                              hoverable
                              style={{
                                width: "100%",
                                textAlign: "center",
                                padding: "8px",
                                border: isSelected
                                  ? "2px solid #1890ff"
                                  : undefined,
                              }}
                            >
                              {isPdf ? (
                                <div
                                  onClick={() =>
                                    window.open(
                                      `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                      "_blank",
                                    )
                                  }
                                  style={{
                                    height: "120px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#f0f0f0",
                                    borderRadius: "8px",
                                    border: "1px solid #d9d9d9",
                                  }}
                                >
                                  <FilePdfOutlined
                                    style={{
                                      fontSize: "40px",
                                      color: "#ff4d4f",
                                    }}
                                  />
                                  <span
                                    style={{
                                      marginTop: "8px",
                                      fontSize: "12px",
                                      color: "#666",
                                    }}
                                  >
                                    คลิกเพื่อเปิด PDF
                                  </span>
                                </div>
                              ) : (
                                <Image
                                  width="100%"
                                  height="120px"
                                  src={`${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`}
                                  alt={`รูปภาพ ${index}`}
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                  preview={{
                                    src: `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                  }}
                                />
                              )}
                            </Card>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Spin>
              </Form.Item>
            );
          })()}
          <Form.Item label="หมายเหตุ" name="memo">
            <TextArea
              rows={5}
              onChange={(e) => onChangeInputMemo(e.target.value)}
            />
          </Form.Item>
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={handleCancel}
              style={{ color: "red", marginRight: "20px" }}
            >
              ปิด
            </Button>

            <Button style={{ color: "green" }} htmlType="submit">
              บันทึก
            </Button>
          </div>
        </Form>
      </>
    );
  };

  return (
    <>
      <Modal
        title="ลงวันนัดศาล"
        open={open}
        onCancel={handleCancel}
        width={850}
        footer={null}
      >
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Card>
            <FormDisabledDemo />
          </Card>
        </Spin>
      </Modal>
      {isModalClearAdvancePayment && (
        <ClearAdvancePaymentOnce
          open={isModalClearAdvancePayment}
          close={setIsModalClearAdvancePayment}
          dataDefault={dataDefault}
          funcUpdateStatus={handleCancel}
          // company={companieSelect}
        />
      )}
    </>
  );
};
export default UpdateStatusBlackNumber;
